export const arms = [
    'hands-x', 'hands-y', 'swim-hands', 'swing-hands',
    "left-hand-up", "right-hand-up", 'crazy',
]
export const abdomen = ['poshup', 'baly-run', 'baly-legs']
export const legs_knees = [
    'left-leg-up', 'right-leg-up', 'legs-both-up',
    '90leging-right', '90leging-left',
]
export const lower_back = [
    'back-down', 'toch-flor'
]
export const upper_back = [
    'claping', 'all-up-1'
]
export const allbody = [
    'gamp', 'legs-gumping', 'open-close',
    'kicks', 'pray', 'right-all', 'up-dwon-both',
    'gump-sides', 'zomba'
]

export const activities = {
    arms: [
        'hands-x', 'hands-y', 'swim-hands', 'swing-hands',
        "left-hand-up", "right-hand-up", 'crazy',],
    abdomen: ['poshup', 'baly-run', 'baly-legs'],
    legs_knees: [
        'left-leg-up', 'right-leg-up', 'legs-both-up',
        '90leging-right', '90leging-left'
    ],
    lower_back: [
        'back-down', 'toch-flor'
    ],
    upper_back: [
        'claping', 'all-up-1'
    ],
    allbody: [
        'gamp', 'legs-gumping', 'open-close',
        'kicks', 'pray', 'right-all', 'up-dwon-both',
        'gump-sides', 'zomba'
    ]
}